import {createSlice} from "@reduxjs/toolkit";
import {addDrawer, fetchActiveDrawer} from "./globalComponentsThunks";

export const activeDrawerSlice = createSlice({
    name: 'activeDrawer',
    initialState: {
        activeDrawer: null,
    },
    loading: null,
    error: null,
    reducers: {
        updateActiveDrawer: (state, action) => {
            state.activeDrawer = action.payload; // Update the active appbar with the new data
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchActiveDrawer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchActiveDrawer.fulfilled, (state, action) => {
                state.loading = false;
                state.activeDrawer = action.payload; // Set the active appbar
            })
            .addCase(fetchActiveDrawer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message; // Capture any error that occurs
            })
            .addCase(addDrawer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addDrawer.fulfilled, (state, action) => {
                state.loading = false;
                state.activeDrawer = action.payload; // Update the active appbar with the newly added one
            })
            .addCase(addDrawer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message; // Capture any error that occurs
            });
    }
})

export const {updateActiveDrawer} = activeDrawerSlice.actions;
export default activeDrawerSlice.reducer;